import { tr } from 'mmfintech-commons'
import { useCryptoCurrencyNotes } from 'mmfintech-checkout-commons'

import type { CryptoNotesDetails } from 'mmfintech-checkout-commons/types'

import InfoIcon from '../../assets/icons/info-circle.svg'

import './warningMessage.scss'

const WarningMessage = ({ currency }) => {
  const notes = useCryptoCurrencyNotes(currency, true)

  if (notes) {
    return (
      <div className='warning-message-wrapper'>
        <div className='warning-message-heading'>
          <img src={InfoIcon} alt='' />
          <span>{tr('FRONTEND.DEPOSIT.CRYPTO_DETAILS.PLEASE_NOTE', 'Please note')}</span>
        </div>

        {notes.map((line: CryptoNotesDetails) => (
          <p key={line.keyName}>{tr(line.keyName, line.defaultValue)}</p>
        ))}
      </div>
    )
  }

  return null
}

export default WarningMessage
